var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dialogRoot",
      staticClass: "selectProjectDialogRoot",
      attrs: {
        role: "dialog",
        "aria-labelledby": "textInputMsgTitle",
        "aria-describedby": "textInputMsg"
      }
    },
    [
      _c("div", { staticClass: "titleBar" }, [
        _c(
          "div",
          {
            staticClass: "title",
            attrs: { id: "textInputMsgTitle", role: "alert" }
          },
          [
            _vm.title
              ? [_vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")]
              : [_vm._v("\n\t\t\t\tSelect a Project\n\t\t\t")]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dialogBody" }, [
        _vm.error
          ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
          : _vm.loading
          ? _c(
              "div",
              { staticClass: "loading" },
              [_c("ScaleLoader"), _vm._v(" Loading…")],
              1
            )
          : _vm.projects && _vm.projects.length > 0
          ? _c(
              "div",
              _vm._l(_vm.projects, function(p) {
                return _c(
                  "div",
                  { key: p.Name, staticClass: "projectListItem" },
                  [
                    _c(
                      "a",
                      {
                        class: {
                          projectButton: true,
                          selectedProjectButton:
                            _vm.currentSelectedProjectName === p.Name
                        },
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            return _vm.projectClicked(p)
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\t" + _vm._s(p.Name) + "\n\t\t\t\t")]
                    )
                  ]
                )
              }),
              0
            )
          : _c("div", [
              _vm._v(
                "\n\t\t\tNo projects are accessible by your user account.\n\t\t"
              )
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "div",
          {
            staticClass: "dialogButton okButton",
            attrs: { tabindex: "0" },
            on: {
              click: _vm.okClicked,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ]) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.okClicked($event)
              }
            }
          },
          [_vm._v("\n\t\t\tOK\n\t\t")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dialogButton cancelButton",
            attrs: { tabindex: "0" },
            on: {
              click: _vm.cancelClicked,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ]) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.cancelClicked($event)
              }
            }
          },
          [_vm._v("\n\t\t\tCancel\n\t\t")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }